import { TextField, TextFieldProps } from "@mui/material";
import getTestId from "../../utils/getTestId";

type TextInputExtendedProps = TextFieldProps & {
  label: string;
  index?: number;
};

const TextInput = ({ label, index, ...rest }: TextInputExtendedProps) => {
  return (
    <TextField
      label={label}
      data-testid={getTestId({ label, index })}
      {...rest}
      sx={{
        ...rest.sx,
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: `solid 1.5px rgba(0, 0, 0, 0.4) !important`,
        },
        ".Mui-focused": {
          color: "rgba(0, 0, 0, 0.6) !important",
        },
      }}
    />
  );
};

export default TextInput;
